import React from "react";
import {
  FaHeart,
  FaLeaf,
  FaGraduationCap,
  FaUsers,
  FaSeedling,
  FaBriefcase,
} from "react-icons/fa";

const AboutUs = () => {
  const pillars = [
    {
      icon: <FaBriefcase />,
      title: "Livelihood",
      desc: "Skill training & income generation",
    },
    {
      icon: <FaUsers />,
      title: "Social Awareness",
      desc: "Rights, health & digital literacy",
    },
    {
      icon: <FaLeaf />,
      title: "Environment",
      desc: "Green initiatives & sustainability",
    },
    {
      icon: <FaGraduationCap />,
      title: "Education",
      desc: "Quality learning for all ages",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#eafaff] via-white to-[#dff7fb] py-14 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block bg-white text-[#1298b5] border border-[#bdeef5] px-4 py-1.5 rounded-full text-sm font-semibold mb-4 shadow-sm">
            About Aabharan Foundation
          </span>

          <h1 className="text-4xl md:text-5xl font-extrabold text-[#073b4c] mb-4">
            The Heart of{" "}
            <span className="text-[#1298b5]">Aabharan</span>
          </h1>

          <div className="w-24 h-1 bg-gradient-to-r from-[#1298b5] to-[#f97316] mx-auto rounded-full"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 mb-14">
          <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-lg p-7 md:p-8 border border-[#d8f4f8] hover:shadow-xl transition-all duration-300">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#1298b5] to-[#0b819b] text-white flex items-center justify-center text-2xl mb-5 shadow-md">
              <FaHeart />
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-[#073b4c] mb-4">
              Who We Are
            </h2>

            <p className="text-gray-600 text-base md:text-lg leading-relaxed">
              At Aabharan Foundation, we believe that true progress is not just
              about individual growth, but about lifting an entire community
              together. Registered as a Section 8 NGO, we are dedicated to
              creating a "Jewel of Hope" for the underserved sections of society.
              Our work spans across the vital pillars of Livelihood, Social
              Awareness, Environment, and Education.
            </p>
          </div>

          <div className="bg-[#073b4c] rounded-3xl shadow-lg p-7 md:p-8 border border-[#1298b5]/40 hover:shadow-xl transition-all duration-300">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#f97316] to-[#fb923c] text-white flex items-center justify-center text-2xl mb-5 shadow-md">
              <FaSeedling />
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Why We Started
            </h2>

            <p className="text-gray-200 text-base md:text-lg leading-relaxed">
              We noticed a gap where traditional charity often fails to provide
              long-term dignity. Aabharan was born to bridge that gap. Whether
              it is a mother earning her first wage through handmade crafts, a
              village elder learning about digital banking, or a newborn child
              leaving a green footprint on Earth—we are there to nurture every
              step.
            </p>
          </div>
        </div>

        <div className="mt-8">
          <div className="text-center mb-8">
            <h3 className="text-2xl md:text-3xl font-extrabold text-[#073b4c]">
              Our{" "}
              <span className="text-[#1298b5]">Focus Areas</span>
            </h3>

            <div className="w-16 h-1 bg-gradient-to-r from-[#1298b5] to-[#f97316] mx-auto mt-4 rounded-full"></div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
            {pillars.map((pillar, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6 text-center border border-[#d8f4f8] hover:border-[#1298b5]/50 hover:-translate-y-2"
              >
                <div className="w-14 h-14 mx-auto rounded-2xl bg-[#eafaff] text-[#1298b5] group-hover:bg-[#1298b5] group-hover:text-white flex items-center justify-center text-3xl transition-all duration-300 mb-4">
                  {pillar.icon}
                </div>

                <h4 className="font-bold text-[#073b4c] text-sm md:text-base mb-2">
                  {pillar.title}
                </h4>

                <p className="text-gray-600 text-xs md:text-sm leading-relaxed">
                  {pillar.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;